import { render, staticRenderFns } from "./ViewTransaction.vue?vue&type=template&id=03e96d4c&scoped=true"
import script from "./ViewTransaction.vue?vue&type=script&lang=js"
export * from "./ViewTransaction.vue?vue&type=script&lang=js"
import style0 from "./ViewTransaction.vue?vue&type=style&index=0&id=03e96d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e96d4c",
  null
  
)

export default component.exports